import ScoreItem from './ScoreItem';

export default ScoreItem;
